<template>
  <div
    v-show="isShow"
    class="container"
    :style="{width: Window_Size.width + 'px',height: Window_Size.height + 'px'}"
  >
    <div class="btn"
      :style="{
        width: size.btnWidth + 'px',
        height: size.btnHeight + 'px',
        right: size.right + 'px',
        bottom: size.bottom + 'px'
      }"
      @click="hide()"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      isShow: false,
      picInfo: {
        width: 1366,
        height: 768,
        right: 50,
        bottom: 42,
        btnWidth: 125,
        btnHeight: 45,
      },
      size: {}
    }
  },
  computed: {
    ...mapGetters([
      'Window_Size',
      'TOOL',
    ]),
  },
  watch: {
    'Window_Size': {
      handler (val) {
        this.handleSize(val);
      },
      deep: true,
    }
  },
  created () {
    this.$bus.on('userGuide.show', this.show)
    this.$bus.on('userGuide.hide', this.hide)
  },
  methods: {
    show () {
      let stored = this.$util.localStorage.get('UserGuideShown')
      if (stored) {
        return;
      }
      this.$util.localStorage.set('UserGuideShown', true);
      this.handleSize(this.Window_Size);
      this.isShow = true;
    },
    hide () {
      this.isShow = false;
    },
    handleSize (val) {
      // rbw / pbw = ww / pw
      let size = {}
      size.btnWidth = val.width / this.picInfo.width * this.picInfo.btnWidth;
      size.btnHeight = val.height / this.picInfo.height * this.picInfo.btnHeight;
      size.right = val.width / this.picInfo.width * this.picInfo.right;
      size.bottom = val.height / this.picInfo.height * this.picInfo.bottom;
      this.size = size;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  & * {
    color: #474261;
  }
  position: absolute;
  top: 0;
  left: 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(../../../../../static/img/user-guide.png);
}
.btn {
  position: absolute;
  right: 100px;
  bottom: 100px;
  width: 120px;
  height: 40px;
  background-color: transparent;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/modals/userGuide.vue